import { doc, getDoc } from "firebase/firestore";
import { db } from "../../lib/firebase/config";
import { withReadTimeout } from "../../lib/firebase/readTimeout";

/**
 * Recorte de `subscriptions/{uid}` que o client lê fora do painel de
 * assinatura. O doc é `allow read: if isOwner(uid)` — só o próprio dono.
 */
export interface OwnSubscriptionSnapshot {
  plan: string | null;
  status: string | null;
  currentPeriodEnd: number | null;
  grantReason: string | null;
}

/**
 * Leitura one-shot do próprio doc de assinatura — 1 read, com o teto de
 * `withReadTimeout` (transporte morto vira rejeição, não skeleton eterno —
 * BUG-179). `null` quando o doc não existe.
 *
 * Usada pelo aviso de fim do PRO, que precisa saber a ORIGEM do PRO que
 * acabou e só a chama depois que as checagens gratuitas já disseram "vale a
 * pena abrir" — a maioria das sessões não paga este read.
 */
export async function getOwnSubscriptionOnce(uid: string): Promise<OwnSubscriptionSnapshot | null> {
  const snap = await withReadTimeout(getDoc(doc(db, "subscriptions", uid)));
  if (!snap.exists()) return null;
  const data = snap.data() as Record<string, unknown>;
  return {
    plan: typeof data.plan === "string" ? data.plan : null,
    status: typeof data.status === "string" ? data.status : null,
    currentPeriodEnd: typeof data.currentPeriodEnd === "number" ? data.currentPeriodEnd : null,
    grantReason: typeof data.grantReason === "string" ? data.grantReason : null,
  };
}
